export default __webpack_public_path__ + "static/media/filter_icon_vac_blue.1670c513.svg";